module.exports = __webpack_public_path__ + "img/paso1.0525667d.png";